import classNames from 'classnames';

import { formatDuration } from '../../lib/utils';

import DurationTypo from '../typography/Duration';

import styles from '../../styles/partials/duration.module.css';

interface DurationProps {
    duration: number;
    timestamp?: boolean;
    className?: string | null;
}

function Duration({ duration, timestamp = false, className = null }: DurationProps) {
    let formattedDuration = duration < 60 ? `${duration} sec` : `${Math.round(duration / 60)} min`;
    if (timestamp) {
        formattedDuration = formatDuration(duration);
    }
    return (
        <DurationTypo className={classNames([styles.container, className])}>
            {formattedDuration}
        </DurationTypo>
    );
}

export default Duration;
